import React from 'react';
import { Container, Typography, Button } from '@material-ui/core';
import { useHistory, Link } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import './Landing.css';
import LearningStrategiesSection from '../../components/LearningStrategiesSection';

function Landing() {
  const history = useHistory();

  return (
    <div className="landing-root">
      {/* Header */}
      <header className="landing-header">
        <img 
          src="https://ia.intelladapt.ai/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.bb151063.png&w=256&q=75" 
          alt="Learning Strategy Logo" 
          className="landing-logo-img" 
        />
        <nav className="landing-nav">
          <Link to="/">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/login" className="landing-nav-login-btn">Login</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <Container className="landing-hero" maxWidth="md">
        <Typography variant="h2" className="landing-title" gutterBottom>
          Transforming Education With Learning Strategy™
        </Typography>
        <Typography variant="h5" className="landing-subtitle" gutterBottom>
          Revolutionizing education by harnessing Adaptive Intelligence™ to create truly personalized learning experiences that adapt in real-time to each student's unique cognitive profile.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="landing-getstarted"
          onClick={() => history.push('/login')}
        >
          Get Started
        </Button>
        
        <LearningStrategiesSection />
      </Container>

      {/* Evolution of Learning */}
      <Container className="landing-section" id="about" maxWidth="md">
        <Typography variant="h4" gutterBottom>The Evolution of Learning: From One-Size-Fits-All to Personalized Intelligence</Typography>
        <Typography variant="body1" paragraph>
          Traditional education has long followed a standardized approach, treating all learners the same despite their individual differences. At the core of our mission is a fundamental belief: every person has a unique learning strategy based on their individual cognitive development. Our pioneering Adaptive Intelligence™ technology recognizes and responds to these differences, creating a learning experience as unique as each student.
        </Typography>
      </Container>

      {/* Science of Brainwave Adaptive Learning */}
      <Container className="landing-section" id="solution" maxWidth="md">
        <Typography variant="h4" gutterBottom>The Science of Learning Strategy™</Typography>
        <ul className="landing-bullets">
          <li>Every individual has a learning strategy based on their unique cognitive development</li>
          <li>Adapting to the individual allows educators to reach higher completion rates and deeper learning</li>
          <li>Anyone can reach learning competency with the right learning strategy and pace of learning</li>
          <li>Instructors remain essential guides, helping students learn how to learn, not just what to learn</li>
          <li>"One size fits all" approaches fail because they ignore cognitive diversity</li>
          <li>Information overload is not education—effective learning requires understanding the cognitive process</li>
          <li>Meaningful assessment helps learners improve and reach desired competency levels</li>
        </ul>
      </Container>

      {/* Adaptive Intelligence Section */}
      {/* Removed as per request */}

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-footer-social">
          <a href="https://www.facebook.com/intelladapt" target="_blank" rel="noopener noreferrer"><FacebookIcon /></a>
          <a href="https://twitter.com/intellADAPT" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
          <a href="https://www.youtube.com/channel/UC32UTPjMhG0tKz25jspcKIQ" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
          <a href="https://www.linkedin.com/company/5346214" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
        </div>
        <div className="landing-footer-copy">© 2026 intellAdapt. All rights reserved.</div>
      </footer>
    </div>
  );
}

export default Landing; 